import { useState, useEffect } from 'react';
import { fetchCategories, deleteCategories } from '../../services/AdminCategoryService';

const useCategoryActions = () => {
  const [categories, setCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    loadCategories();
  }, []);

  useEffect(() => {
    filterCategories();
  }, [searchTerm, categories]);


  const clearSelectedCategories = () => {
    const updatedCategories = filteredCategories.map((categorie) => ({
      ...categorie,
      isSelected: false
    }));
    setFilteredCategories(updatedCategories);
    setSelectedCategories([]);
  };

  const loadCategories = async () => {
    try {
      const data = await fetchCategories();
      setCategories(data);
      setFilteredCategories(data);
    } catch (error) {
      console.error('Error loading categories:', error);
    }
  };

  const handleBulkDelete = async (selectedCategories) => {
    try {
      const categoryIds = selectedCategories.map(category => category.id);
      await deleteCategories(categoryIds);
    } catch (error) {
      console.error('Error deleting categories:', error);
    }
  };

  const handleFilter = (searchTerm) => {
    setSearchTerm(searchTerm);
  };

  const filterCategories = () => {
    let filtered = categories;

    if (searchTerm) {
      filtered = filtered.filter(
        (category) =>
          category.id.toString().includes(searchTerm.toLowerCase()) ||
          category.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredCategories(filtered);
  };

  const handleSelectAll = (isSelected) => {
    const updatedCategories = filteredCategories.map(category => {
      if (category.is_default) {
        return { ...category, isSelected: false };
      }
      return { ...category, isSelected: isSelected };
    });
    setFilteredCategories(updatedCategories);
    const selectableCategories = updatedCategories.filter(category => !category.is_default);
    setSelectedCategories(isSelected ? selectableCategories : []);
  };

  const handleCategorySelect = (categoryId, isSelected) => {
    const updatedCategories = filteredCategories.map((category) =>
      category.id === categoryId ? { ...category, isSelected: isSelected } : category
    );
    setFilteredCategories(updatedCategories);

    if (isSelected) {
      const selectedCategory = filteredCategories.find(category => category.id === categoryId);
      setSelectedCategories([...selectedCategories, selectedCategory]);
    } else {
      setSelectedCategories(selectedCategories.filter((category) => category.id !== categoryId));
    }
  };

  return {
    categories,
    filteredCategories,
    selectedCategories,
    loadCategories,
    handleBulkDelete,
    handleFilter,
    handleSelectAll,
    handleCategorySelect,
    clearSelectedCategories
  };
};

export default useCategoryActions;